import { DialogActions } from '@game-libs/models';
import { EventsManager } from '@game-libs/events-manager';
import { AudioManager } from '@game-libs/audio-manager';
import { Engine } from 'excalibur';
import { GUIActions } from '../types/game-types';
import { GameplayEvents } from '../types/game-events';
import { openLink } from '../utils/open-links';

export const initDialogListeners = (game: Engine) => {
  const { playTyping, playSFXNow, stop } = AudioManager();
  const { on, emit } = EventsManager();

  on(DialogActions.TYPING, (speaker: string) => {
    playTyping(speaker);
  });

  on('wishlist', () => {
    openLink('https://store.steampowered.com/app/3834590/Now_THATS_a_Big_Dragon?utm_source=itchio');
  });

  on('bigger_dragon', () => {
    playSFXNow('far_roar');
    stop('game_music');

    setTimeout(() => {
      document.body.classList.add('shaking');
      playSFXNow('stomps', 1.5);
      emit(GUIActions.MET_DRAGON);
    }, 500);

    setTimeout(() => {
      document.body.classList.remove('shaking');
      playSFXNow('big_roar', 1.2);
      emit(GameplayEvents.STUN_UNITS);
    }, 7500);
  });

  on('thats', () => {
    playSFXNow('thats');
  });
};
